import { IAppConfig } from '../interface/IAppConfig';

export const AppConfigService = (_apiAwsHost: string | null): IAppConfig => {
    const context = window.topContext;
    const siteConfig = context.config.getSiteConfig();
    const endpointConfig = context.config.getEndpointConfig();
    const apiAwsHost = _apiAwsHost || endpointConfig.apiAwsHost;

    return {
        apiAwsHost: apiAwsHost,
        appName: 'onsa-b2b',
        baseName: '/',
        environment: siteConfig.environment,
        logLevel: siteConfig.logLevel,
        logger: endpointConfig.logger,
        objectCacheUrl: apiAwsHost + '/objects',
        resourceBundles: {},
        contentBlocks: {},
        wso2ApiHost: endpointConfig.wso2host,
        wso2ApiUrl: apiAwsHost + '/proxy/v2/onlinesales-services-b2b/api',
        wso2OpenApiUrl: apiAwsHost + '/proxy/v2/openapi/onlinesales-services-b2b/api',
    };
};
